import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  FormControlLabel,
  Grid2,
  List,
  Popover,
  Radio,
  styled,
  Typography,
} from "@mui/material";
import {
  PrimaryFormActionButton,
  PrimaryTooltip,
} from "../../../Components/StyledComponent";
import SearchInput from "./SearchInput";
import FilterSelectBox from "./FilterSelectBox";
import { useTranslation } from "react-i18next";

const popoverPaperStyles = {
  py: "20px",
  px: "16px",
  borderRadius: "10px",
  backgroundColor: "#FFFFFF",
  boxShadow:
    "2px 2px 4px 0px rgba(151, 151, 151, 0.25), -2px -2px 4px 0px rgba(151, 151, 151, 0.25)",
};

const ItemRowRadioLabel = styled(FormControlLabel)(({ theme }) => ({
  display: "block",
  marginLeft: 0,

  ".MuiButtonBase-root": {
    padding: 0,
  },

  ".MuiRadio-root": {
    padding: 0,
    color: "#A2A2A2 !important",

    "&.Mui-checked": {
      color: "#6D72F6 !important",
    },
    "&.Mui-disabled": {
      color: "#A2A2A2 !important",
    },
  },

  ".MuiSvgIcon-root": {
    width: "20px",
    height: "20px",
  },
}));

/* Component */
const SingleSelectDropdown = ({ selectedOption, options, label, onChange }) => {
  const { t } = useTranslation(["common"]);

  const [anchorEl, setAnchorEl] = useState(null);
  const [selected, setSelected] = useState(selectedOption);
  const [search, setSearch] = useState("");

  const open = Boolean(anchorEl);

  /* ---------- UI ---------- */
  const filteredOptions = useMemo(() => {
    if (!search.trim()) return options;
    return options.filter((item) =>
      item.toLowerCase().includes(search.toLowerCase())
    );
  }, [options, search]);

  const handleOnApply = () => {
    onChange(selected);
    setAnchorEl(null);
  };

  const handleSelection = (option) => {
    setSelected(option);
  };

  useEffect(() => {
    if (open) {
      setSelected(selectedOption);
    }
  }, [open]);

  useEffect(() => {
    setSelected(selectedOption);
  }, [selectedOption]);

  useEffect(() => {
    if (options.length > 0 && !selectedOption) {
      setSelected(options[0]);
    }
  }, [options]);

  if (options.length === 1) {
    return (
      <Box>
        <FilterSelectBox
          open={false}
          onClick={() => {}}
          label={label}
          displayValue={options[0]}
          disabled={true}
        />
      </Box>
    );
  }

  return (
    <>
      <Box>
        <FilterSelectBox
          open={open}
          onClick={(e) => setAnchorEl(e.currentTarget)}
          label={label}
          displayValue={selectedOption || `Select ${label}`}
        />
      </Box>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        slotProps={{ paper: { sx: popoverPaperStyles } }}
      >
        <Grid2
          container
          flexDirection={"column"}
          gap={2}
          sx={{ width: "315px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              variant="fw700s14lh24c3D4B5A"
              sx={{ textTransform: "capitalize" }}
            >
              Select {label}
            </Typography>
          </Box>

          <SearchInput
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder={`Search ${label}`}
          />

          <Box sx={{ height: "200px", overflowY: "auto" }}>
            <List disablePadding>
              {filteredOptions.map((option, index) => {
                return (
                  <Grid2
                    key={index}
                    container
                    gap={2}
                    alignItems="center"
                    sx={{ py: 0.5 }}
                  >
                    <ItemRowRadioLabel
                      key={option}
                      disabled={false}
                      control={
                        <Radio
                          checked={selected === option}
                          onChange={() => handleSelection(option)}
                        />
                      }
                      label={
                        <Typography
                          variant={
                            true ? "fw400s12lh24c3D4B5A" : "fw400s12lh24c989898"
                          }
                        >
                          {" "}
                          {option}{" "}
                        </Typography>
                      }
                    />
                  </Grid2>
                );
              })}
            </List>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 1.5,
            }}
          >
            <PrimaryFormActionButton
              onClick={handleOnApply}
              disabled={!selected}
            >
              Apply
            </PrimaryFormActionButton>
          </Box>
        </Grid2>
      </Popover>
    </>
  );
};

export default SingleSelectDropdown;
